import React, {useState, useEffect} from 'react';
import * as Yup from 'yup';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Form, Formik, FormikProps } from 'formik';


import { addUrl } from './helper';
import {withFormikFormControl} from "../../FormikFormControl";
import {ProgressSpinner} from "primereact/progressspinner";
import {Card} from "primereact/card";

export type ModalInputURLProps = OpenControls & {
  onChangeAttachments: (results: Omit<Attachment, 'id' | 'filename'>[]) => void;
};


const ModalInputURL = ({ handleClose, isOpen, onChangeAttachments }: ModalInputURLProps) => {
  const [url, setUrl] = useState('')


  const renderForm = () => {
    const handleClickUpload = (e) => {
      e.preventDefault();

      if (!url) return;

      try {
        onChangeAttachments( [
          addUrl(url)
        ])
        setUrl('')
        handleClose()
      } catch (error) {
        // eslint-disable-next-line
        console.log('Error in File Upload from URL =>', error);

      }

    };

    return (
      <Card title={'Enter URL'} footer={<Button
          label="Import URL"
          icon="pi pi-check"
          autoFocus
          disabled={!url}
          onClick={handleClickUpload}
      />}>
        <InputText name="url" value={url} onChange={e => setUrl(e.target.value)} style={{width: '100%', marginBottom: '10px'}}/>

      </Card>
    );
  };

  return (
    <Dialog
      header="URL To Import as Attachment"
      visible={isOpen}
      onHide={handleClose}
      draggable={false}
      breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw'}}
    >
      {renderForm()}
    </Dialog>
  );
};

export default ModalInputURL;
